import { connect } from 'react-redux';
import DuePaymentsList, { DUE_PAYMENTS_MODE } from "./DuePaymentsList";
import { getTranslation } from "../../../../reducers/common/localization";
import {
    fetchGetDuePaymentsForBAs,
    loadingBAsDuePayments,
    getBAsDuePaymentsData,
    getContinentFilterForBAsDuePayments,
    updateContinentFilterForBAsDuePayments,
    onUpdateContinentFilterForBAsDuePayments,
    getNameFilterForBAsDuePayments,
    updateNameFilterForBAsDuePayments
} from '../../../../reducers/systemPayments/duePayments';
import { showModal, MODAL_BA_WIRE_DATA, MODAL_BA_DUE_PAYMENT_CONFIRM } from '../../../../reducers/common/activeModal';
import { getContinentsData } from '../../../../reducers/common/location';
import { resetSubmitFormData } from '../../../../reducers/common/submitForm';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        mode: DUE_PAYMENTS_MODE.BA,
        loading: loadingBAsDuePayments(state),
        data: getBAsDuePaymentsData(state),
        continentFilter: getContinentFilterForBAsDuePayments(state),
        continents: getContinentsData(state),
        nameFilter: getNameFilterForBAsDuePayments(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetDuePaymentsForBAs());
        },
        onShowWireDataModal: () => {
            dispatch(showModal({ modalKey: MODAL_BA_WIRE_DATA }))
        },
        onShowDuePaymentsConfirmModal: () => {
            dispatch(resetSubmitFormData());
            dispatch(showModal({ modalKey: MODAL_BA_DUE_PAYMENT_CONFIRM }))
        },
        onChangeContinentFilter: (continentCode) => {
            dispatch(updateContinentFilterForBAsDuePayments(continentCode))
        },
        onUnmount: () => {
            dispatch(onUpdateContinentFilterForBAsDuePayments(null))
        },
        onUpdateNameFilter: (name) => {
            dispatch(updateNameFilterForBAsDuePayments(name))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DuePaymentsList);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsList/BAsDuePaymentsList.container.js